import React from 'react'
import { Box, IconButton, Typography } from '@mui/material'
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded'
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded'
import { advancedColors } from '../theme'

type Props = {
  label: string
  unit: 'day' | 'week' | 'month'
  onStep: (delta: number) => void
  labelWidth?: number
}

const PeriodNavigator = ({ label, unit, onStep, labelWidth = 140 }: Props) => (
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 1.5 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <IconButton size="small" onClick={() => onStep(-1)} aria-label={`Previous ${unit}`}>
        <ChevronLeftRoundedIcon fontSize="small" />
      </IconButton>
      <Typography
        variant="subtitle2"
        sx={{ color: advancedColors.inkMuted, minWidth: labelWidth, textAlign: 'center' }}
      >
        {label}
      </Typography>
      <IconButton size="small" onClick={() => onStep(1)} aria-label={`Next ${unit}`}>
        <ChevronRightRoundedIcon fontSize="small" />
      </IconButton>
    </Box>
  </Box>
)

export default PeriodNavigator
